module.exports = __webpack_public_path__ + "img/美丽一生（诗丽堂）.e75a298.png";